export const repeatedMethodsMixin = {
    methods: {
        currentDate(){
            const date = new Date(new Date().toString().split('GMT')[0]+' UTC').toISOString()
            return date;
        },
        mobile() {
            return (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm);
        },
        hashCode(str) { // java String#hashCode
            var hash = 0;
            for (var i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
            }
            return hash;
        },
        intToRGB(i){
            var c = (i & 0x00FFFFFF)
            .toString(16)
            .toUpperCase();
            
            return "00000".substring(0, 6 - c.length) + c;
        },
        secondsToDays(i){
            return Math.floor(i / (3600 * 24));
        },
        secondsToHours(i){
            return Math.floor((i % (3600 * 24)) / 3600);
        },
        secondsToMinutes(i){
            return Math.floor((i % 3600) / 60);
        },
        strip(html){
            let doc = new DOMParser().parseFromString(html, 'text/html');
            return doc.body.textContent || "";
        },
        calculatePercentage(num1, num2) {
            if (num2 === 0) {
              return 0; 
            }
            let percentage = (num1 / num2) * 100;
            return Math.round(percentage);
        },  
    }
}